import Url_pdf from "../json/texts.json";

export default function PDF(UrlCaminho) {
   // URL com base no ambiente
   if (window.location.href.includes("localhost") || window.location.href.includes("10.5")) {
      return `${Url_pdf.STATIC_URL_PDF_DEV}${UrlCaminho}`;
   }
   if (window.location.href.includes("rh.fiecdev")) {
      return `${Url_pdf.STATIC_URL_PDF_PROD}${UrlCaminho}`;
   }
   // Fallback opcional se nenhum dos casos acima se aplicar
   return "";
}
